import api from './api';

/**
 * @param {string} tokenIds
 * @returns {Promise<{ url: string }>}
 */
export default async function getResults(tokenIds) {

    const { data } = await api.post('exportResults', {
        tokens: tokenIds.map(id => ({ token_id: id })),
    });

    return data;
}